/* eslint-disable max-len */
import React from 'react';
import { Redirect } from 'wouter';
import { useResolve } from '../Container';
import { ProfileModel } from '../ProfileModel';
import { AccountModel } from '../account/AccountModel';
import { Page2 } from '../common/Page2';
import { Copy, Em, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { NewNavigationView } from './navigation/NewNavigationView';

export const OhNoPage = () => {
    const user = useResolve(ProfileModel);
    const account = useResolve(AccountModel);

    const anyTeam = account.workspaces.find(x => x.type === 'team');
    if (!!anyTeam) {
        return <Redirect to={`~/${anyTeam.id}/boards`} />;
    }

    // const param = params.param;
    // useReturnLocation(`/${entityId}`);
    return <Page2 navigation={NewNavigationView}>
        <Page2.Content>
            <Flexer absolute inset flex center>
                <Flexer flex="column" gap="1" maxWidth="32">
                    <Title size="3xl" flush>You're not in a team yet!</Title>
                    <Copy size="1.25">
                        Looks like you are a member of <Em>{account.label}</Em> but haven't been assigned a team!
                        Ask an admin for either a team invite link or a board link to get started.
                    </Copy>
                </Flexer>
            </Flexer>
        </Page2.Content>
    </Page2>;
};
